import { ENV, Environment } from '@repo/constants'
import { FEATURE_FLAGS_ENV } from '@repo/feature-flags'

type Config = {
  env: Environment
  backendURL: string
  featureFlags: (typeof FEATURE_FLAGS_ENV)[Environment]
  /** Where the team reads client recordings; only where the recorder runs. */
  testLabURL: string | null
  commitSha: string
}

const commitSha = import.meta.env.VITE_COMMIT_SHA ?? 'prod'

const isEmulator = window.location.hostname === '10.0.2.2'

const local: Config = {
  env: ENV.LOCAL,
  featureFlags: FEATURE_FLAGS_ENV.LOCAL,
  testLabURL: 'http://localhost:5190',
  commitSha,
  backendURL: isEmulator ? 'http://10.0.2.2:8080' : 'http://localhost:8080',
}

const dev: Config = {
  env: ENV.DEV,
  featureFlags: FEATURE_FLAGS_ENV.DEV,
  testLabURL: 'https://dev.test-lab.petrafi.com',
  commitSha,
  backendURL: 'https://dev.api.petrafi.com',
}

const staging: Config = {
  env: ENV.STAGING,
  featureFlags: FEATURE_FLAGS_ENV.STAGING,
  testLabURL: 'https://dev.test-lab.petrafi.com',
  commitSha,
  backendURL: 'https://staging.api.petrafi.com',
}

const prod: Config = {
  env: ENV.PROD,
  featureFlags: FEATURE_FLAGS_ENV.PROD,
  testLabURL: 'https://dev.test-lab.petrafi.com',
  commitSha,
  backendURL: 'https://api.petrafi.com',
}

const configs: Record<Environment, Config> = {
  [ENV.LOCAL]: local,
  [ENV.DEV]: dev,
  [ENV.PROD]: prod,
  [ENV.STAGING]: staging,
}

function getEnvConfig(): Config {
  const env = import.meta.env.VITE_FRONTEND_ENV as Environment | undefined
  if (env && env in configs) {
    return configs[env]
  }
  return local
}

const config = getEnvConfig()
export default config
